import * as React from "react";
import "./labelWithIcon.scss";
import {isNullOrUndefined} from "util";
import IconWrapper from "../Icon/IconWrapper";
import {Icon} from "../Icon/Icon";
import classNames = require("classnames");

interface IProps {
	/**
	 * Input value.
	 */
	value: string | number | JSX.Element;
	/**
	 * Placeholder string.
	 */
	placeholder: string;
	/**
	 * Indicates if field is disabled.
	 */
	disabled?: boolean;
	/**
	 * Input click callback
	 */
	onClick?: (evt: React.MouseEvent<HTMLDivElement>) => void;
	/**
	 * Prepend Icon name.
	 */
	prependIcon?: string;
	/**
	 * Prepend icon click callback.
	 * @param {React.MouseEvent<SVGSVGElement>} evt
	 */
	onPrependIconClick?: (evt: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Append icon name.
	 */
	appendIcon?: string;
	/**
	 * Append icon click callback.
	 * @param {React.MouseEvent<SVGSVGElement>} evt
	 */
	onAppendIconClick?: (evt: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Indicates if input field has clear icon.
	 */
	clearable?: boolean;
	/**
	 * Clear icon click callback
	 */
	onClearClick?: () => void
}

export default class LabelWithIcon extends React.Component<IProps, {}> {
	constructor(props: IProps) {
		super(props);
		this.renderPrependIcon = this.renderPrependIcon.bind(this);
		this.renderAppendIcon = this.renderAppendIcon.bind(this);
		this.renderClear = this.renderClear.bind(this);
	}

	render() {

		const styleFromProps = this.props.disabled ? {cursor: "not-allowed"} : {};
		const classFromProps = classNames({
			"a-label-with-icon": true,
			"is-disabled": this.props.disabled,
			"placeholder": this.shouldShowPlaceholder(),
			"clearable": this.props.clearable,
		});

		return (
			<div className={classFromProps} onClick={this.props.onClick}>
				{this.renderPrependIcon()}
				{this.renderAppendIcon()}
				<label style={styleFromProps}>
					{this.shouldShowPlaceholder() ? this.props.placeholder : this.props.value}
				</label>
			</div>
		);
	}

	shouldShowPlaceholder() {
		return this.props.value.toString().length == 0;
	}

	/**
	 * Indicates if icon should be grayed.
	 * @return {boolean | undefined}
	 */
	private isIconGray() {
		return !Boolean(this.props.value) || this.props.disabled;
	}

	/**
	 * Render prepend icon.
	 * @return {JSX.Element}
	 */
	private renderPrependIcon() {
		if (!isNullOrUndefined(this.props.prependIcon)) {
			return (
				<span className={"a-label-with-icon_icon-prepend"}>
					<IconWrapper icon={this.props.prependIcon}
								 disabled={this.props.disabled}
								 size={18}
								 variant={this.isIconGray() ? "gray" : "blue"}
								 onClick={this.props.disabled ? () => {} : this.props.onPrependIconClick}/>
				</span>
			);
		}
	}

	/**
	 * Render append icon.
	 * @return {JSX.Element}
	 */
	private renderAppendIcon() {
		if (!isNullOrUndefined(this.props.appendIcon)) {
			return (
				<span className={"a-label-with-icon_icon-append"}>
					{this.renderClear()}
					<IconWrapper icon={this.props.appendIcon}
								 disabled={this.props.disabled}
								 size={18}
								 variant={this.isIconGray() ? "gray" : "blue"}
								 onClick={this.props.disabled ? null : this.props.onAppendIconClick}/>
				</span>
			);
		}
		else {
			this.renderClear()
		}
	}

	/**
	 * render clear icon
	 * @returns {JSX.Element}
	 */
	renderClear() {
		return (
			!this.isIconGray() && this.props.clearable &&
			<IconWrapper icon={Icon.X}
						 size={18}
						 variant={"blue"}
						 onClick={(e) => {
							 e.stopPropagation();
							 this.props.onClearClick();
						 }}/>)
	}

}
